import { render, staticRenderFns } from "./JobTemplateDetails.vue?vue&type=template&id=40205d72&scoped=true&"
import script from "./JobTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./JobTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobTemplateDetails.vue?vue&type=style&index=0&id=40205d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40205d72",
  null
  
)

export default component.exports